import { mensagemPadrao } from 'src/dados-estaticos'
import * as Yup from 'yup'

export const schema = Yup.object().shape({
  dataPagamento: Yup.string().data().required(mensagemPadrao),
  valorPagamento: Yup.number().nullable().required(mensagemPadrao),
  formaPagamento: Yup.string().required(mensagemPadrao),
  comprovante: Yup.string().notRequired()
})
